import { all, put, take, select, actionChannel } from 'redux-saga/effects';
import { GET_ANNOTATIONS, SET_IFRAME_ATTRIBUTES, GET_PAGE_BREAKS } from './actions';
import { SAVE_TOC, SAVE_TITLE, SAVE_PAGE_BREAKS } from 'Reducers/dataModels';
import { SAVE_BOOK_PAGE_BREAK } from 'Reducers/compModels';
import { getChapter, getChapters } from 'Lib/getChapter';
import getPage from 'Lib/getPage';

function* setIframeTitle() {
  const chan = yield actionChannel(SAVE_BOOK_PAGE_BREAK);
  yield all([
    take(SAVE_TITLE),
    take(SAVE_TOC),
    take(SAVE_PAGE_BREAKS),
  ]);
  const { toc, title, pageBreaks } = yield select();
  const chapters = getChapters(toc);
  while(true) {
    const { data: pageLabel } = yield take(chan);
    if (pageLabel) {
      const page = getPage(pageBreaks.pages, pageLabel);
      if (page) {
        const chapter = getChapter(chapters, page);
        const iframeTitle = (chapter ? `${title} | ${chapter.title}` : title);
        const iframe = document.getElementsByTagName('iframe')[0];
        iframe.setAttribute('title', iframeTitle);
      }
    }
  }
}


function* setIframeAttributes() {
  yield take(SET_IFRAME_ATTRIBUTES);
  const iframe = document.getElementsByTagName('iframe')[0];
  iframe.setAttribute('allowfullscreen', true);
  iframe.setAttribute('webkitallowfullscreen', true);
  iframe.setAttribute('mozallowfullscreen', true);
  iframe.setAttribute('title', 'Ereader');

  yield all([
  	put({ type: GET_ANNOTATIONS }),
  	put({ type: GET_PAGE_BREAKS }),
  ]);
}

export default function* rootSaga() {
  yield all([
    setIframeAttributes(),
    setIframeTitle(),
  ]);
}
